import { useEffect } from "react";

const DEFAULT_TITLE = "Artist's Studio Gallery — Landscape Paintings & Notecards by Richard Kuensting";

export default function Seo({ title, description }) {
  useEffect(() => {
    document.title = title ? `${title} — Artist's Studio Gallery` : DEFAULT_TITLE;
    if (description) {
      document.querySelector('meta[name="description"]')?.setAttribute("content", description);
    }
  }, [title, description]);
  return null;
}
